import {Box, Grid, Link, List, ListItem, ListItemIcon, ListItemText, Stack, Typography, useTheme} from '@mui/material';
import PartnerData from './PartnershipPageData.json';
import {CircleFill, Launch} from '@carbon/icons-react';

const PartnershipPage = () => {
  const theme = useTheme();
  return (
    <Box px={6} py={4} pb={12}>
      <Stack spacing='20px'>
        <Grid container>
          <Grid item xs={12} md={8} lg={6}>
            <Typography variant='h6'>{PartnerData.description}</Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} md={8} lg={6}>
            <List>
              {PartnerData.list.map((listItem) => (
                <ListItem key={listItem} disablePadding>
                  <ListItemIcon style={{minWidth: 'auto', marginRight: '8px'}}>
                    <CircleFill color={theme.palette.grey[800]} width='5px' height='5px' />
                  </ListItemIcon>
                  <ListItemText primary={listItem} />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
        <Box />
        <Box />
        <Grid container spacing='20px' columnGap='20px'>
          {PartnerData.partners.map((partner) => (
            <Grid item xs={12} md={6} lg={3} key={partner.name}>
              <Stack spacing={'20px'}>
                <Typography variant='h4'>{partner.name}</Typography>
                <Typography variant='h6'>
                  For the {partner.name} site — access should be requested via the{' '}
                  <Link color='primary' underline='hover' href={`mailto:${partner.email}`}>
                    {partner.email}
                  </Link>{' '}
                  mailbox
                </Typography>
                <Box />
                <Link
                  color='primary'
                  underline='hover'
                  onClick={() => window.open(partner.link, '_blank')}
                  rel='noopener noreferrer'
                  sx={{cursor: 'pointer'}}
                  display='flex'
                  rowGap='10px'
                >
                  <Stack direction='row' spacing='10px'>
                    <Typography variant='h5' fontWeight={400}>
                      {partner.link_text}
                    </Typography>{' '}
                    <Launch color={theme.palette.primary.main} width='18px' height='18px' />
                  </Stack>
                </Link>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  );
};

export default PartnershipPage;
